<div class="search-field-wrapper">
    <input type="text" [value]="value" (input)="handleInput($event)" [disabled]="disabled"
        [placeholder]="placeholder || 'Please search...'" />
    <div class="search-icon"><img src="../../../assets/icons/icon-search-new.svg" width="19.8" height="20.51" /></div>

</div>
<span *ngIf="showMatchCount && matchCount !== null" class="match-count"
    style="margin-left: 8px; min-width: 80px; color: #666; font-size: 14px;">
    {{ matchCount }} match{{ matchCount === 1 ? '' : 'es' }}
</span>